import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/data';

export default function ArticleListPage() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const articleListJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: t('seo.article_list_title'),
    description: t('seo.article_list_desc'),
    url: 'https://huangguan-sports.com/articles',
  };

  return (
    <>
      <SEOHead
        title={t('seo.article_list_title')}
        description={t('seo.article_list_desc')}
        keywords={t('seo.article_list_keywords')}
        canonicalUrl="https://huangguan-sports.com/articles"
      />
      <script type="application/ld+json">{JSON.stringify(articleListJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="px-4 md:px-6 py-6">
          <div className="max-w-5xl mx-auto">
            <Breadcrumb items={[{ label: t('article.list_title') }]} />

            <div className="mb-10">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
                {t('article.list_title')}
              </h1>
              <p className="text-foreground-500 text-base">{t('article.list_subtitle')}</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
                >
                  <div className="sm:w-48 flex-shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 p-4 md:p-5 flex flex-col justify-between min-w-0">
                    <div>
                      <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2 flex-wrap">
                        <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-600 font-medium">
                          {article.category === 'football' ? '足球' : article.category === 'basketball' ? '篮球' : article.category === 'tennis' ? '网球' : '电竞'}
                        </span>
                        <span>{article.date}</span>
                      </div>
                      <h2 className="font-bold text-foreground-900 text-base mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                        {article.title}
                      </h2>
                      <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">{article.excerpt}</p>
                    </div>
                    <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                      <span>{article.author}</span>
                      <span>{article.views.toLocaleString()} 阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}